import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  'FETCH_MESSAGE_TO_ACCOUNTANT_TOPICS',
  '!CREATE_MESSAGE_TO_ACCOUNTANT',
  '!SET_SLIDE_OVER_OPEN',
] as const

export default serviceActionsGenerator('message-to-accountant', actionTypes)
